import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransportOrderListItemDto } from "../../../models/transport/transportOrder";

export interface TransportOrderState {
    transportOrders: TransportOrderListItemDto[];
}

const initialState: TransportOrderState = {
    transportOrders: [],
};

export const transportOrderSlice = createSlice({
    name: "transportOrders",
    initialState,
    reducers: {
        setTransportOrders: (state, action: PayloadAction<TransportOrderListItemDto[]>) => {
            state.transportOrders = action.payload;
        },
    }
});

export const { setTransportOrders } = transportOrderSlice.actions;
export const transportOrderReducer = transportOrderSlice.reducer;
